export function getNestedValue<T>(obj: T, path: string): any {
	if (!obj || !path) return undefined;

	return path.split('.').reduce((acc: any, key) => {
		if (Array.isArray(acc)) {
			return acc.map((item) => (item && key in item ? item[key as keyof typeof item] : undefined)).filter((value) => value !== undefined);
		}

		if (acc && key in acc) {
			return acc[key as keyof typeof acc];
		}

		console.warn(`Key "${key}" not found in`, acc);
		return undefined;
	}, obj);
}
